<!--
 * @Description  : 
 * @Author       : BigBigger
 * @Date         : 2025-10-12 15:53:53
 * @LastEditTime : 2025-10-12 16:21:58
 * @LastEditors  : BigBigger
-->
<!--我的课程-->
<template>
  <van-tabs v-model="active">
    <van-tab title="网课">
      <Course :type="1" />
    </van-tab>
    <van-tab title="面授">
      <Course :type="2" />
    </van-tab>
  </van-tabs>
</template>
<script>
import Course from './course.vue';

export default {
  name:'course',
  data() {
    return{
      active: 0, // 课程组列表
    }
  },
  components: {
    Course
  },
  methods: {
    pageChange(page) {
      this.page = page
      this.getCourseGroup();
    },
    jumpDetail(item) {
      this.$router.push({path:`/course/${item.id}`})
    },
    // 获取课程组
    async getCourseGroup() {
      const params = {
        page: 1,
        limit: 1000
      }
      let response = await getOwnCourseGroup(params)
      if(+response.returnCode !== 10001) {
        return false
      }
      this.courseGroupList = response.data
      this.total = response.total
      this.loading = false;
      this.finished = true;
    },
  }
}
</script>
<style lang="less">
</style>
